<template>
  <div class="app-container">
    <el-form
      :inline="true"
      :model="searchForm"
      class="demo-form-inline"
      label-position="top"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item class="numberSearch" label="">
            <template slot="label">
              <el-select v-model="type1" :placeholder="$t('CenterForSorting.pleaseChoose')">
                <el-option :label="$t('CenterForSorting.scanNumber')" value="scanOrderNumberList" />
                <el-option
                  :label="$t('CenterForSorting.waybillNumber')"
                  value="waybillNumberList"
                />
              </el-select>
            </template>
            <InputTextareaCmp
              ref="inputTextareaRef"
              :max-length="2000"
              :min-rows="2"
              :val="listVal"
              @input="(_, val) => (listVal = val)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('CenterForSorting.timeRange')">
            <el-date-picker
              v-model="searchForm.createTime"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('CenterForSorting.endTime')"
              :picker-options="pickerOptions"
              :start-placeholder="$t('CenterForSorting.startTime')"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @focus="pickDate = null"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="margin-top: 28px">
            <el-button
              icon="el-icon-search" size="mini" type="primary"
              @click="handleSearch"
            >{{ $t('CenterForSorting.search') }}
            </el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="resetSearch">{{ $t('CenterForSorting.reset') }}
            </el-button>
            <!--导出-->
            <el-button size="small" type="primary" @click="allExportOrder">{{ $t('collectionCenter.export') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <el-card>
      <el-table
        v-loading="listLoading"
        :data="tableData"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          :label="$t('CenterForSorting.ind')"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column
          :label="$t('CenterForSorting.scanNumber')"
          align="center"
          min-width="160"
          prop="scanOrderNumber"
        />
        <el-table-column
          :label="$t('CenterForSorting.waybillNumber')"
          align="center"
          min-width="160"
          prop="waybillNumber"
        />
        <el-table-column
          :label="$t('CenterForSorting.machineCode')"
          align="center"
          prop="machineCode"
          width="130"
        />
        <el-table-column
          :label="$t('CenterForSorting.lengthWithUnit')"
          align="center"
          prop="length"
          width="120"
        />
        <el-table-column
          :label="$t('CenterForSorting.widthWithUnit')"
          align="center"
          prop="width"
          width="120"
        />
        <el-table-column
          :label="$t('CenterForSorting.heightWithUnit')"
          align="center"
          prop="height"
          width="120"
        />
        <el-table-column
          :label="$t('CenterForSorting.weightWithUnit')"
          align="center"
          prop="weight"
          width="120"
        />
        <el-table-column :label="$t('CenterForSorting.pictureUrl')" align="center" min-width="140">
          <template slot-scope="{ row }">
            <el-image
              v-if="getPicUrlList(row.picUrl).length"
              :preview-src-list="getPicUrlList(row.picUrl)"
              :src="getPicUrlList(row.picUrl)[0]"
              fit="cover"
              style="width: 40px; height: 40px"
            />
            <span v-else>{{ $t('CenterForSorting.noData') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('CenterForSorting.createTime')"
          align="center"
          prop="createTime"
          width="180"
        />
      </el-table>

      <!-- 分页工具 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="listQuery.pageNumber"
          :page-size.sync="listQuery.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="fetchData"
          @size-change="fetchData"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import InputTextareaCmp from '@/views/finance/cmp/Query/InputTextareaCmp.vue';
import { getWeighingRecordPage } from '@/api/sorting/weighingRecord';
import { goResourceTaskList } from '@/utils/goExportList';
import { weighingRecordExportAll } from '@/api/sorting/record';

export default {
  name: 'WeighingRecord',
  components: {
    InputTextareaCmp
  },
  data() {
    return {
      type1: 'scanOrderNumberList',
      listVal: '',
      tableData: [],
      total: 0,
      listLoading: true,
      listQuery: {
        pageNumber: 1,
        pageSize: 10
      },
      searchForm: {
        createTime: this.getDefaultTimeRange()
      },
      pickDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickDate = minDate;
          if (maxDate) {
            this.pickDate = null;
          }
        },
        disabledDate: (time) => {
          if (this.pickDate) {
            const oneDay = 24 * 3600 * 1000;
            const minTime = this.pickDate.getTime() - 6 * oneDay;
            const maxTime = this.pickDate.getTime() + 6 * oneDay;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return false;
        }
      }
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    getDefaultTimeRange() {
      const start = new Date();
      start.setHours(0, 0, 0, 0);
      const end = new Date();
      end.setHours(23, 59, 59, 999);

      const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        const h = String(date.getHours()).padStart(2, '0');
        const min = String(date.getMinutes()).padStart(2, '0');
        const s = String(date.getSeconds()).padStart(2, '0');
        return `${y}-${m}-${d} ${h}:${min}:${s}`;
      };

      return [formatDate(start), formatDate(end)];
    },
    getPicUrlList(picUrl) {
      if (!picUrl) return [];
      if (Array.isArray(picUrl)) {
        return picUrl
          .filter((item) => item)
          .map((item) => String(item).trim())
          .filter((item) => item);
      }
      return String(picUrl)
        .split(',')
        .map((item) => item.trim())
        .filter((item) => item);
    },
    fetchData() {
      // 校验时间范围不能为空
      if (!this.searchForm.createTime || this.searchForm.createTime.length !== 2) {
        this.$message.warning(this.$t('CenterForSorting.timeRangeRequired'));
        this.listLoading = false;
        return;
      }

      // 验证时间范围不超过7天
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        const start = new Date(this.searchForm.createTime[0]).getTime();
        const end = new Date(this.searchForm.createTime[1]).getTime();
        const diff = end - start;
        const days = diff / (1000 * 60 * 60 * 24);
        if (days > 7) {
          this.$message.warning(this.$t('CenterForSorting.queryTimeLimit'));
          this.listLoading = false;
          return;
        }
      }

      this.listLoading = true;
      const params = {
        pageNumber: this.listQuery.pageNumber,
        pageSize: this.listQuery.pageSize,
        params: {
          createTimeBegin: this.searchForm.createTime && this.searchForm.createTime[0],
          createTimeEnd: this.searchForm.createTime && this.searchForm.createTime[1]
        }
      };

      const inputVal = this.$refs.inputTextareaRef ? this.$refs.inputTextareaRef.getValue() : [];
      if (inputVal && inputVal.length > 0) {
        params.params[this.type1] = inputVal;
      }

      getWeighingRecordPage(params)
        .then((response) => {
          this.tableData = response.data.records || [];
          this.total = response.data.total || 0;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    handleSearch() {
      this.listQuery.pageNumber = 1;
      this.fetchData();
    },
    resetSearch() {
      // 重置查询条件并恢复默认时间范围
      this.type1 = 'scanOrderNumberList';
      this.listVal = '';
      this.searchForm = {
        createTime: this.getDefaultTimeRange()
      };
      this.handleSearch();
    },
    // 导出
    allExportOrder() {
      // 校验时间范围不能为空
      if (!this.searchForm.createTime || this.searchForm.createTime.length !== 2) {
        this.$message.warning(this.$t('CenterForSorting.timeRangeRequired'));
        return;
      }
      // 验证时间范围不超过7天
      if (this.searchForm.createTime && this.searchForm.createTime.length === 2) {
        const start = new Date(this.searchForm.createTime[0]).getTime();
        const end = new Date(this.searchForm.createTime[1]).getTime();
        const diff = end - start;
        const days = diff / (1000 * 60 * 60 * 24);
        if (days > 7) {
          this.$message.warning(this.$t('CenterForSorting.queryTimeLimit'));
          return;
        }
      }
      const params = {
        createTimeBegin: this.searchForm.createTime && this.searchForm.createTime[0],
        createTimeEnd: this.searchForm.createTime && this.searchForm.createTime[1]
      };
      const inputVal = this.$refs.inputTextareaRef ? this.$refs.inputTextareaRef.getValue() : [];
      if (inputVal && inputVal.length > 0) {
        params[this.type1] = inputVal;
      }
      weighingRecordExportAll(params).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    }
  }
};
</script>

<style scoped>
.numberSearch ::v-deep .el-input--small .el-input__inner {
  line-height: 28px;
  height: 28px;
  border: none;
  padding-left: 0;
  font-weight: bold;
}
</style>
